module.exports = __webpack_public_path__ + "img/jmcd-part-fa-pic1.bab8f508.png";